import { ExternalAssets } from '@/types/externalURLs'

/** Site-wide default OG image used when a page declares no bespoke image. */
export const DEFAULT_OG_IMAGE = ExternalAssets.SiteOGImage

/** Resolve the OG image URL for a page: its own `ogImage`, else the site default. */
export function getOgImage(config: { ogImage?: string }): string {
  return config.ogImage ?? DEFAULT_OG_IMAGE
}
